class BESSAppAccountSettings extends BESSAppBase {

    constructor() {
        super();
        this.root = $('.app-account-settings');
        if (this.root.length === 0) {
            return;
        }

        this.details = new BESSAppAccountDetails();
        this.emailPreferences = new BESSAppAccountEmailPreferences();
        this.changePassword = new BESSAppAccountChangePassword();
        this.training = new BESSAppAccountTrainingPreferences();
    }
}